<label class="custom-checkbox"  [htmlFor]="guid">
  <input type="checkbox" [disabled]="isDisabled" class="hidden" [checked]="isChecked" (change)="toggleCheckBox()"  [id]="guid">
  <div class="checkbox-box border-2" [ngClass]="{'bg-green-300': isChecked,'bg-standardwhite':!isChecked&&!isDisabled, 'border-green-700': isChecked,'border-grey-500':!isChecked,'bg-grey-900':isDisabled}" style="display: flex; align-items: center; justify-content: center;  border-radius: 4px; width: 20px; height: 20px;">
    @if (isChecked) {
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="display: block;">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    }
  </div>
</label>